var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainitem",on:{"click":function($event){return _vm.goodclick('projectdetail')}}},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_c('div',{staticClass:"mainitemimg"},[_c('img',{attrs:{"src":_vm.project.thumbnail,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"mainitemtitle"},[_vm._v(_vm._s(_vm.project.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6419c26a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/short-project-item copy.vue
// module id = null
// module chunks = 